export default __webpack_public_path__ + "static/media/stock-preview.149f27d1.png";